module.exports = __webpack_public_path__ + "media/mascot/mascot6-68c4f581.png";